import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";
import { useIsMobile } from "@/hooks/use-mobile";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();
  const isMobile = useIsMobile();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      // VIB-953: top-right dekket header-ikonene (varsler/avatar/logout). Chat-
      // launcheren ligger bottom-right, så vi bruker bottom-center på desktop —
      // klar av både header og chat. Mobil beholder top-center.
      position={isMobile ? "top-center" : "bottom-center"}
      duration={3500}
      className="toaster group"
      toastOptions={{
        unstyled: false,
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:!border-[1.5px] group-[.toaster]:!border-foreground group-[.toaster]:!rounded-md group-[.toaster]:!shadow-[0_8px_24px_-8px_rgba(8,31,59,0.18)] group-[.toaster]:font-body",
          title: "group-[.toast]:font-medium group-[.toast]:text-foreground",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:!bg-primary group-[.toast]:!text-primary-foreground group-[.toast]:!border-[1.5px] group-[.toast]:!border-primary group-[.toast]:!rounded-md",
          cancelButton:
            "group-[.toast]:!bg-card group-[.toast]:!text-foreground group-[.toast]:!border-[1.5px] group-[.toast]:!border-foreground group-[.toast]:!rounded-md",
          success:
            "group-[.toaster]:!bg-[#D9F5E8] group-[.toaster]:!text-[#035C39] group-[.toaster]:!border-foreground",
          error:
            "group-[.toaster]:!bg-[#FFE1DB] group-[.toaster]:!text-[#7F1D1D] group-[.toaster]:!border-foreground",
          warning:
            "group-[.toaster]:!bg-[#FEF3C7] group-[.toaster]:!text-[#78350F] group-[.toaster]:!border-foreground",
          info:
            "group-[.toaster]:!bg-card group-[.toaster]:!text-foreground group-[.toaster]:!border-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
